module.exports = __webpack_public_path__ + "img/stock7.ab55d359.png";